// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3yG82","header":"MessagesList_header__SGvgc","chat":"MessagesList_chat__3kHBZ"};